import { render } from "./AddAttendance.vue?vue&type=template&id=12838066"
import script from "./AddAttendance.vue?vue&type=script&lang=js"
export * from "./AddAttendance.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__